import { storeToRefs } from 'pinia';
import { computed, watch } from 'vue';
import { useAuthStore } from '~/store/auth';
import { useChatPanelStore, type ChatPage } from '~/store/chatPanel';
import { isSystemManager } from '~/utils/account';
import { canSeeChatAssistant } from '~/utils/chat-panel';

/**
 * The visibility of the chat assistant "Suge" for the signed-in user. canSeeChatAssistant() owns
 * the rule. The feature keys come from the organization and not from the shop.
 */
export function useChatAssistantVisible() {
  const config = useRuntimeConfig();
  const { operator, currentOrganization } = storeToRefs(useAuthStore());
  return computed(() =>
    canSeeChatAssistant(
      {
        isSystemManager: isSystemManager(operator.value),
        organizationFeatureKeys: currentOrganization.value?.features.map(feature => feature.key) ?? [],
      },
      String(config.public.agentApiUrl ?? ''),
    ),
  );
}

/** Gives the current page to the chat panel store, for the context chip. The panel stays open. */
export function useChatPageTracking(page: () => ChatPage) {
  const panel = useChatPanelStore();
  watch(page, value => panel.pageChanged(value), { immediate: true, deep: true });
}
